<template>
  <div class="home_news_event">
    <div
      class="gdlr-core-pbf-wrapper "
      style="padding: 80px 0px 30px 0px;"
      data-skin="Blut Title Column Service"
    >
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js ">
        <div
          class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container"
        >
          <div class="gdlr-core-pbf-element">
            <div
              class="gdlr-core-event-item gdlr-core-item-pdb"
              style="padding-bottom: 25px ;"
            >
              <div
                class="gdlr-core-block-item-title-wrap  gdlr-core-left-align gdlr-core-item-mglr"
                style="margin-bottom: 37px ;"
              >
                <div class="gdlr-core-block-item-title-inner clearfix">
                  <h3
                    class="gdlr-core-block-item-title"
                    style="font-size: 24px ;font-style: normal ;text-transform: none ;letter-spacing: 0px ;color: #163269 ;"
                  >
                    Pengumuman
                  </h3>
                  <div
                    class="gdlr-core-block-item-title-divider"
                    style="font-size: 24px ;border-bottom-color: #dcdcdc ;border-bottom-width: 2px ;"
                  ></div>
                </div>
                <router-link
                  class="gdlr-core-block-item-read-more"
                  :to="`/pengumuman`"
                  target="_self"
                  style="color: #3db166 ;"
                  >Lihat semua pengumuman</router-link
                >
              </div>
              <div class="gdlr-core-event-item-holder clearfix">
                <div
                  v-for="(announc, index) in announcement.slice(1, 4)"
                  :key="`annon_${index}`"
                  data-aos="fade-in"
                  :data-aos-duration="index + `000`"
                  :data-aos-delay="index + `00`"
                  class="gdlr-core-event-item-list gdlr-core-style-grid gdlr-core-item-pdlr gdlr-core-column-20  clearfix"
                >
                  <div class="gdlr-core-event-item-thumbnail">
                    <a href="#"
                      ><img
                        class="img-fluid img-announcement"
                        :src="announc.image"
                        width="900"
                        height="500"
                        alt=""
                    /></a>
                  </div>
                  <span
                    class="gdlr-core-event-item-info gdlr-core-type-start-date-month"
                    ><span class="gdlr-core-date">{{
                      formattedDateDay(announc.published_at)
                    }}</span
                    ><span class="gdlr-core-month">{{
                      formattedDateMonth(announc.published_at)
                    }}</span></span
                  >
                  <div class="gdlr-core-event-item-content-wrap">
                    <h3 class="gdlr-core-event-item-title">
                      <a href="#">{{ announc.title }}</a>
                    </h3>
                    <div class="gdlr-core-event-item-info-wrap">
                      <span
                        class="gdlr-core-event-item-info gdlr-core-type-time"
                        ><span class="gdlr-core-head"
                          ><i class="icon_clock_alt"></i></span
                        ><span class="gdlr-core-tail">{{
                          formattedClock(announc.published_at)
                        }}</span></span
                      ><span
                        class="gdlr-core-event-item-info gdlr-core-type-location"
                        ><span class="gdlr-core-head"
                          ><i class="icon_profile"></i></span
                        ><span class="gdlr-core-tail">{{
                          announc.author
                        }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gdlr-core-pbf-element">
            <div
              class="gdlr-core-blog-item gdlr-core-item-pdb clearfix  gdlr-core-style-blog-column"
              style="padding-bottom: 0px ;"
            >
              <div
                class="gdlr-core-block-item-title-wrap  gdlr-core-left-align gdlr-core-item-mglr"
                style="margin-bottom: 40px ;"
              >
                <div class="gdlr-core-block-item-title-inner clearfix">
                  <h3
                    class="gdlr-core-block-item-title"
                    style="font-size: 24px ;font-style: normal ;text-transform: none ;letter-spacing: 0px ;color: #163269 ;"
                  >
                    Berita &amp; Update
                  </h3>
                  <div
                    class="gdlr-core-block-item-title-divider"
                    style="font-size: 24px ;border-bottom-width: 2px ;"
                  ></div>
                </div>
                <a
                  class="gdlr-core-block-item-read-more"
                  href="#"
                  target="_self"
                  style="color: #3db166 ;"
                  >Baca Semua Berita</a
                >
              </div>
              <div
                class="gdlr-core-blog-item-holder gdlr-core-js-2 clearfix"
                data-layout="fitrows"
              >
                <div
                  v-for="(newsItem, index) in news.slice(1, 4)"
                  :key="`item_${index}`"
                  data-aos="zoom-in"
                  :data-aos-duration="index + `000`"
                  :data-aos-delay="index + `00`"
                  class="gdlr-core-item-list  gdlr-core-item-pdlr gdlr-core-column-20"
                >
                  <div class="gdlr-core-blog-grid ">
                    <div
                      class="gdlr-core-blog-thumbnail gdlr-core-media-image  gdlr-core-opacity-on-hover gdlr-core-zoom-on-hover"
                    >
                      <router-link :to="`/berita-detail/${newsItem.url}`">
                        ><img
                          class="img-fluid img-news"
                          :src="newsItem.image"
                          width="900"
                          height="500"
                          alt=""
                      /></router-link>
                    </div>
                    <div class="gdlr-core-blog-grid-content-wrap">
                      <div
                        class="gdlr-core-blog-info-wrapper gdlr-core-skin-divider"
                      >
                        <span
                          class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-date"
                          ><router-link
                            :to="`/berita-detail/${newsItem.url}`"
                            >{{ newsItem.published_at }}</router-link
                          ></span
                        ><span
                          class="gdlr-core-blog-info gdlr-core-blog-info-font gdlr-core-skin-caption gdlr-core-blog-info-category"
                          ><router-link
                            :to="`/berita-detail/${newsItem.url}`"
                            rel="tag"
                            >{{
                              newsItem.author != null
                                ? newsItem.author
                                : `Staff`
                            }}</router-link
                          ></span
                        >
                      </div>
                      <h3
                        class="gdlr-core-blog-title gdlr-core-skin-title"
                        style="font-size: 17px ;font-weight: 600 ;letter-spacing: 0px ;"
                      >
                        <router-link :to="`/berita-detail/${newsItem.url}`">{{
                          newsItem.title
                        }}</router-link>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "announcement",
  props: ["news", "announcement"],

  methods: {
    formattedDate(date) {
      moment.locale("id");
      return moment(date).format("DD MMMM YYYY HH:MM");
    },
    formattedDateDay(date) {
      moment.locale("id");
      return moment(date).format("DD");
    },
    formattedDateMonth(date) {
      moment.locale("id");
      return moment(date).format("MMM");
    },
    formattedClock(date) {
      moment.locale("id");
      return moment(date).format("HH:MM");
    },
  },
};
</script>
